module.exports = __webpack_public_path__ + "static/project-intra.297f68c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/project-intra.jpg
// module id = 451
// module chunks = 35783957827783